import { useMemo } from 'react';

import useLocale from '@watershed/intl/frontend/useLocale';
import { CommandListItem } from '@watershed/shared-frontend/components/CommandPalette/kit/CommandList';
import CommandListPage from '@watershed/shared-frontend/components/CommandPalette/kit/CommandListPage';
import { PermissionlessFieldInfo } from '@watershed/shared-frontend/exchanges/gqlPermissionWarningExchange';

interface GqlPermissionlessFieldPathsPageProps {
  fieldInfo: PermissionlessFieldInfo;
}

export default function GqlPermissionlessFieldPathsPage({
  fieldInfo,
}: GqlPermissionlessFieldPathsPageProps) {
  const locale = useLocale();

  const commands = useMemo(() => {
    return Array.from(new Set(fieldInfo.paths))
      .map((path) => {
        return {
          id: path,
          title: path,
          onSelect: (_, palette) => {
            void navigator.clipboard.writeText(path);
            palette.close();
          },
        } satisfies CommandListItem<unknown>;
      })
      .toSorted((a, b) => a.title.localeCompare(b.title, locale));
  }, [fieldInfo.paths, locale]);

  return (
    <CommandListPage
      commands={commands}
      searchPlaceholder="Search paths"
      enterActionLabel="Copy to clipboard"
      searchMode="fuzzy"
    />
  );
}
